module.exports = __webpack_public_path__ + "static/logo-d790835fd9e6fbe7df82958292c9b8c7.png";